export var RegionalSettingNames;
(function (RegionalSettingNames) {
    RegionalSettingNames["INTERNATIONAL"] = "international";
    RegionalSettingNames["US"] = "us";
    RegionalSettingNames["UK"] = "uk";
})(RegionalSettingNames || (RegionalSettingNames = {}));
export var AreaOfInterest;
(function (AreaOfInterest) {
    AreaOfInterest["breeder"] = "breeder";
    AreaOfInterest["farmer"] = "farmer";
})(AreaOfInterest || (AreaOfInterest = {}));
export var UserAgreementsList;
(function (UserAgreementsList) {
    UserAgreementsList["SERVICE_AGREEMENTS"] = "serviceAgreements";
})(UserAgreementsList || (UserAgreementsList = {}));
export var UserErrors;
(function (UserErrors) {
    UserErrors["USER_NOT_FOUND"] = "UserNotFound";
    UserErrors["INVALID_COUNTRY"] = "InvalidCountry";
    UserErrors["INVALID_STATE"] = "InvalidState";
    UserErrors["INVALID_TOKEN"] = "InvalidToken";
    UserErrors["USER_ALREADY_ENABLE"] = "UserAlreadyEnable";
    UserErrors["TOKEN_EXPIRED"] = "TokenExpired";
})(UserErrors || (UserErrors = {}));
//# sourceMappingURL=user.types.js.map